import { BillingEvent } from '@epilot/customer-portal-client'

export const MOCK_PAYMENTS: { results: BillingEvent[]; hits: number } = {
  results: [
    {
      type: 'installment',
      _org: '739224',
      _title: 'installment 30.1.2025',
      _schema: 'billing_event',
      _tags: ['='],
      billing_amount: 10050,
      billing_amount_decimal: '100.50',
      billing_currency: 'EUR',
      external_id: 'd4fb2a4e-3f74-4fc4-8fba-6fdaaaa3b08e',
      contract: {
        $relation: [{ entity_id: 'e51b1722-19ab-4b90-b57e-ab4e01c21912' }]
      },
      due_date: new Date().toISOString(),
      _id: '064f6581-6373-4190-9737-8fe766a95f8e',
      _created_at: '2025-01-15T16:16:32.357Z',
      _updated_at: '2025-01-15T16:16:32.357Z',
      _relations: [
        {
          entity_id: 'e51b1722-19ab-4b90-b57e-ab4e01c21912'
        }
      ]
    },
    {
      type: 'installment',
      _org: '739224',
      _title: 'installment 18.2.2025',
      _schema: 'billing_event',
      _tags: ['='],
      billing_amount: 10050,
      billing_amount_decimal: '100.50',
      billing_currency: 'EUR',
      external_id: 'd4fb2a4e-3f74-4fc4-8fba-6fdaaaa3b08e',
      contract: {
        $relation: [{ entity_id: 'e51b1722-19ab-4b90-b57e-ab4e01c21912' }]
      },
      due_date: new Date().toISOString(),
      _id: 'f8a8dea2-3b31-4b44-9717-638edfeb4a57',
      _created_at: '2025-01-31T11:27:19.385Z',
      _updated_at: '2025-01-31T11:27:19.385Z',
      _relations: [
        {
          entity_id: 'e51b1722-19ab-4b90-b57e-ab4e01c21912'
        }
      ]
    },
    {
      type: 'installment',
      _org: '739224',
      _title: 'installment 30.1.2025',
      _schema: 'billing_event',
      _tags: ['='],
      billing_amount: 10050,
      billing_amount_decimal: '100.50',
      billing_currency: 'EUR',
      external_id: 'd4fb2a4e-3f74-4fc4-8fba-6fdaaaa3b08e',
      contract: {
        $relation: [{ entity_id: 'e51b1722-19ab-4b90-b57e-ab4e01c21912' }]
      },
      due_date: new Date().toISOString(),
      _id: '064f6581-6373-4190-9737-8fe766a95f8e',
      _created_at: '2025-01-15T16:16:32.357Z',
      _updated_at: '2025-01-15T16:16:32.357Z',
      _relations: [
        {
          entity_id: 'e51b1722-19ab-4b90-b57e-ab4e01c21912'
        }
      ]
    },
    {
      type: 'installment',
      _org: '739224',
      _title: 'installment 18.2.2025',
      _schema: 'billing_event',
      _tags: ['='],
      billing_amount: 10050,
      billing_amount_decimal: '100.50',
      billing_currency: 'EUR',
      external_id: 'd4fb2a4e-3f74-4fc4-8fba-6fdaaaa3b08e',
      contract: {
        $relation: [{ entity_id: 'e51b1722-19ab-4b90-b57e-ab4e01c21912' }]
      },
      due_date: new Date().toISOString(),
      _id: 'f8a8dea2-3b31-4b44-9717-638edfeb4a57',
      _created_at: '2025-01-31T11:27:19.385Z',
      _updated_at: '2025-01-31T11:27:19.385Z',
      _relations: [
        {
          entity_id: 'e51b1722-19ab-4b90-b57e-ab4e01c21912'
        }
      ]
    }
  ],
  hits: 4
}
